import ControlOptions from "slotworks/smart-ui/options/control-options";
import ValueList from "slotworks/utils/value-list";

class AutoplayModel {

    public enabled = true;

    public autoplays: ValueList<number> = new ValueList();
    public singleWinLimit: ValueList<number> = new ValueList();
    public totalWinLimit: ValueList<number> = new ValueList();
    public lossLimit: ValueList<number> = new ValueList();

    public lossLimitRequired: boolean = true;

    public stopOnFeatureWin: boolean = false;
    public stopOnAnyWin: boolean = false;

    public runningWinLoss: number = 0;

    private startConfirmed: boolean;
    private flashLossLimit: boolean = false;

    private firstAutoplay: boolean = false;

    private customSpinCountSelected: boolean = false;
    private customLossLimitSelected: boolean = false;
    private customSingleWinLimitSelected: boolean = false;

    private initialAutoplays: number = 0;

    constructor() {
        this.autoplays.currentValue = 0;
        this.singleWinLimit.currentValue = 0;
        this.totalWinLimit.currentValue = 0;
        this.lossLimit.currentValue = 0;
    }

    public confirm() {
        this.initialAutoplays = this.autoplays.currentValue;
        this.autoplays.currentValue--;
        this.runningWinLoss = 0;
        this.startConfirmed = true;
        this.firstAutoplay = true;
    }

    public setAutoplays(autoplays: number) {
        if (autoplays < 0) {
            this.autoplays.currentValue = 0;
        } else {
            this.autoplays.currentValue = autoplays;
        }
    }

    public getAutoplays(): number {
        return this.autoplays.currentValue;
    }

    public isFirstAutoplay(): boolean {
        return this.startConfirmed && this.firstAutoplay;
    }

    public isAutoPlaying(): boolean {
        return this.startConfirmed;
    }

    public decrease() {
        this.firstAutoplay = false;
        this.autoplays.currentValue--;

        return this.autoplays.currentValue;
    }

    public stop() {
        this.autoplays.currentValue = 0;
        this.startConfirmed = false;
    }

    public getInitialAutoplays() {
        return this.initialAutoplays;
    }

    public injectAutoplayOptions(options: ControlOptions) {

        options.autoplays = this.autoplays.clone();

        options.lossLimit = this.lossLimit.clone();
        options.singleWinLimit = this.singleWinLimit.clone();
        options.totalWinLimit = this.totalWinLimit.clone();

        options.stopOnFeatureWin = this.stopOnFeatureWin;
        options.stopOnAnyWin = this.stopOnAnyWin;

        options.flashLossLimit = this.flashLossLimit;
        options.customAutoplayCountSelected = this.customSpinCountSelected;
        options.customLossLimitSelected = this.customLossLimitSelected;
        options.customSingleWinLimitSelected = this.customSingleWinLimitSelected;
    }

    public updateFromOptions(options: ControlOptions) {
        if (options.autoplays.hasData()) {
            this.setAutoplays(options.autoplays.currentValue);
        }
        if (options.lossLimit.hasData()) {
            this.lossLimit.currentValue = options.lossLimit.currentValue;
        }
        if (options.singleWinLimit.hasData()) {
            this.singleWinLimit.currentValue = options.singleWinLimit.currentValue;
        }
        if (options.totalWinLimit.hasData()) {
            this.totalWinLimit.currentValue = options.totalWinLimit.currentValue;
        }
        if (options.stopOnFeatureWin !== undefined) {
            this.stopOnFeatureWin = options.stopOnFeatureWin;
        }
        if (options.stopOnAnyWin !== undefined) {
            this.stopOnAnyWin = options.stopOnAnyWin;
        }
        if (options.flashLossLimit !== undefined) {
            this.flashLossLimit = options.flashLossLimit;
        }
        if (options.customAutoplayCountSelected !== undefined) {
            this.customSpinCountSelected = options.customAutoplayCountSelected;
        }
        if (options.customLossLimitSelected !== undefined) {
            this.customLossLimitSelected = options.customLossLimitSelected;
        }
        if (options.customSingleWinLimitSelected !== undefined) {
            this.customSingleWinLimitSelected = options.customSingleWinLimitSelected;
        }

    }
}

export default new AutoplayModel();
